import React, { useEffect, useMemo, useState } from 'react'
import SideBarLayout from '../layouts/SideBarLayout'
import Modal from '../components/Modal'
import BowtieDiagram from '../components/diagram/BowtieDiagram'
import Loader from '../components/loaders/Loader'
import { useLocation, useNavigate } from 'react-router-dom'
import instance from '../api/client'
import authService from '../authentication'
import { toast } from 'react-toastify'
import { nodes as initialNodes, edges as initialEdges, edges } from '../components/diagram/initial-elements';

export default function Project({useInitial}) {
  const [loading, setLoading] = useState(false)
  const {state} = useLocation();
  const navigate = useNavigate();

  const [nodesMap, setNodesMap] = useState(new Map());
  const [edgesMap, setEdgesMap] = useState(new Map());

  console.log("nodesMap updated:", nodesMap);
  const nodes = useMemo(() => Array.from(nodesMap.values()), [nodesMap]);
  const edges = useMemo(() => Array.from(edgesMap.values()), [edgesMap]);

  
  useEffect(() => {
      getNodes();
  }, []);

  

  const getNodes = async()=>{
    setLoading(true)
    try {
      const {data, status } = await instance.get(`/bowtie/read-element/${state.diagram.projectCode}/${state.diagram.diagramId}`, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
            // Convert nodes array to Map
          const initNodesMap = new Map(
                data.nodeRequests.map(n => [n.id, n])
          );

            // Flatten edges and convert to Map
          const flatEdges = Object.entries(data.edges).flatMap(([type, edges]) =>
              edges.map(edge => ({ ...edge, edgeType: type }))
          );
          const initEdgesMap = new Map(
              flatEdges.map(e => [e.id, e])
          );

          setNodesMap(initNodesMap);
          setEdgesMap(initEdgesMap);
          setLoading(false);
      }else{
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  return (
    <>
      {loading?
      <div style={{}} className='absolute z-50 flex w-full h-full items-center justify-center bg-modal'>
        <div className=' flex items-center justify-center'>
        <Loader animationName={'collab'} height={300} width={400} />
        </div>
      </div>
      :
      <div className='w-full h-[100vh] bg-gray-800'>
        <BowtieDiagram 
        state={state} 
        initialNodes={nodes} 
        initialEdges={edges} 
        nodesMap = {nodesMap}
        edgesMap = {edgesMap}
        setNodesMap = {setNodesMap} 
        setEdgesMap = {setEdgesMap} />
      </div>
      }
    </>
  )
}
